import { render, staticRenderFns } from "./CommonFormWithDebtorEditor.vue?vue&type=template&id=4d463ff3&lang=pug&"
import script from "./CommonFormWithDebtorEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithDebtorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithDebtorEditor.vue?vue&type=style&index=0&id=4d463ff3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports